var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.active ? 'primary' : '',"small":"","icon":""},on:{"click":_vm.onClick}},[_c('v-icon',{staticClass:"text-primary",attrs:{"small":""}},[(_vm.isDesc)?[_vm._v(" "+_vm._s(_vm.iconAsc)+" ")]:[_vm._v(" "+_vm._s(_vm.iconDesc)+" ")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }